package api.traak.toFirestore

import firebase.firestore.DocumentData
import kotlinx.serialization.Serializable

@Serializable
data class ToFirestoreUpdateTeamRoles(
    val roles: Roles,
) : DocumentData
